import { Component, OnInit, AfterViewInit, ViewChild, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { Comment } from 'ng2-app/modules/comment/models/comment/comment.model';
import { Activity } from 'ng2-app/modules/activity/models/activity/activity.model';
import { CommentService } from 'ng2-app/modules/comment/models/comment/comment.service';
import { take } from 'rxjs/operators';
import { LenderUser } from 'app/models/dto/lender-user.model';

@Component({
    selector: 'borrower-activity-comment-form',
    templateUrl: './borrower-activity-comment-form.component.html',
    styleUrls: ['./borrower-activity-comment-form.component.scss'],
    standalone: false
})
export class BorrowerActivityCommentFormComponent implements OnInit, AfterViewInit {
    @Input() activity: Activity;
    @Input() autofocus: boolean;
    @Input() user: LenderUser;
    @Input() comment: Comment;
    @Output() cancel: EventEmitter<any> = new EventEmitter();
    rawValue = '';
    value = '';
    saving = false;
    disabled = true;

    @ViewChild('textarea', { static: true }) private input: ElementRef;

    constructor( private commentService: CommentService ) { }

    ngOnInit() {
        if (this.comment) {
            this.value = this.comment.content;
            this.rawValue = this.comment.content;
        }
    }

    ngAfterViewInit(): void {
        if (this.autofocus) {
            this.input.nativeElement.focus();
        }
    }

    onChange() {
        this.value = this.rawValue.trim();
        this.setDisabled();
    }

    onBlur() {
        if (!this.value) {
            this.cancel.next(true);
        }
    }

    onCancel() {
        this.rawValue = '';
        this.value = '';
        this.setDisabled();
        this.cancel.next(true);
    }

    onSubmit() {
        if (this.disabled) {
            return;
        }

        this.saving = true;
        this.setDisabled();

        const comment = this.comment ? new Comment(this.comment) : new Comment({
            activityId: this.activity.id,
            borrowerId: this.activity.borrowerId,
            lenderUserId: this.user.id,
            lenderUserName: this.user.fullName
        });

        comment.content = this.value;

        this.commentService.save(comment).pipe(take(1)).subscribe(() => {
            this.saving = false;
            if (!this.comment) {
                this.rawValue = '';
                this.value = '';
            }
            this.setDisabled();
        });
    }

    private setDisabled() {
        this.disabled = !this.user || !this.value || this.saving;
    }
}
